"use client"

import * as React from "react"
import { Link } from "@inertiajs/react"
import { toast } from "sonner"
import { useTheme } from "next-themes"
import { IconMoon, type Icon } from "@tabler/icons-react"

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { Switch } from "@/components/ui/switch"

export function NavSecondary({
  items,
  ...props
}: {
  items: {
    title: string
    url: string
    icon: Icon
  }[]
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const { resolvedTheme, setTheme } = useTheme()
  const isDark = resolvedTheme === "dark"

  const toggleDarkMode = (checked: boolean) => {
    setTheme(checked ? "dark" : "light")
  }

  const handleNotImplemented = (title: string) => {
    toast.info(`${title} is not implemented yet`)
  }

  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              {item.url === "#" ? (
                <SidebarMenuButton onClick={() => handleNotImplemented(item.title)}>
                  <item.icon />
                  <span>{item.title}</span>
                </SidebarMenuButton>
              ) : (
                <SidebarMenuButton asChild>
                  <Link href={item.url}>
                    <item.icon />
                    <span>{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              )}
            </SidebarMenuItem>
          ))}
          <SidebarMenuItem>
            <div className="flex items-center justify-between w-full px-2 py-1.5 text-sm">
              <div className="flex items-center gap-2">
                <IconMoon className="size-4" />
                <span>Dark Mode</span>
              </div>
              <Switch
                checked={isDark}
                onCheckedChange={toggleDarkMode}
              />
            </div>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
